import React, { memo } from 'react';
import { Instagram, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-warm-ivory text-soft-dark py-16 border-t border-soft-terracotta/10" data-id="element-56" data-mp="3gfsja2r5qci8">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-57" data-mp="32oe11y52qfc8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12" data-id="element-58" data-mp="32lrlpcbxyvjg">
          {/* Brand */}
          <div className="flex flex-col items-start" data-id="element-59" data-mp="36n3d9nedlqua">
            <a href="#" className="mb-8 group inline-block" aria-label="Wishing Tree Events home" data-id="element-60" data-mp="3ug3fllb8kjas">
              
              <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/ntvlqtkffhdbb8r9fejcsv/998f55ba-f676-4af8-a27d-47f6f60444b4/Asset_44x.png" alt="Wishing Tree Events" className="h-14 w-auto object-contain" data-id="element-61" data-mp="387drhtbj3d5" />
              
            </a>
            <p className="text-soft-dark font-light text-sm max-w-xs leading-relaxed mb-8" data-id="element-62" data-mp="29yxe3g083qne">
              A gentle approach to bespoke children's celebrations and event
              styling, creating magical memories that last a lifetime.
            </p>
            <div className="flex items-center gap-4" data-id="element-63" data-mp="3lbmw5xyxdiij">
              <a href="#" className="border border-soft-rose/20 p-3 rounded-full text-soft-rose hover:bg-soft-rose hover:text-white transition-all" data-id="element-64" data-mp="3gbiliokp7i08">
                
                <Instagram className="w-4 h-4" strokeWidth={1.5} data-id="element-65" data-mp="3q8wrtvcwqqet" />
              </a>
              <a href="mailto:hello@wishingtreeevents.com" className="border border-powder-blue/20 p-3 rounded-full text-powder-blue hover:bg-powder-blue hover:text-white transition-all" data-id="element-66" data-mp="3qazq12o7rpum">
                
                <Mail className="w-4 h-4" strokeWidth={1.5} data-id="element-67" data-mp="hsttig7oqe35" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-5" data-id="element-68" data-mp="cus1h5sa74fj">
            <h4 className="font-display text-xl text-soft-terracotta mb-2 font-normal" data-id="element-69" data-mp="cw35n6pn2e76">
              Explore
            </h4>
            <a href="#themes" className="text-soft-dark hover:text-soft-rose font-light text-sm transition-colors w-fit tracking-wide" data-id="element-70" data-mp="msg74qrfdwch">
              
              Our Themes
            </a>
            <a href="#packages" className="text-soft-dark hover:text-powder-blue font-light text-sm transition-colors w-fit tracking-wide" data-id="element-71" data-mp="ytxxtlt8ef0y">
              
              Packages & Pricing
            </a>
            <a href="#about" className="text-soft-dark hover:text-soft-butter font-light text-sm transition-colors w-fit tracking-wide" data-id="element-72" data-mp="18kiwtacthlke">
              
              Our Story
            </a>
            <a href="#contact" className="text-soft-dark hover:text-soft-terracotta font-light text-sm transition-colors w-fit tracking-wide" data-id="element-73" data-mp="1hkff8u8m5o70">
              
              Book a Party
            </a>
          </div>

          {/* Contact & Location */}
          <div className="flex flex-col gap-5" data-id="element-74" data-mp="1ri3mukrbiq6l">
            <h4 className="font-display text-xl text-soft-terracotta mb-2 font-normal" data-id="element-75" data-mp="3obomzf7jlhh1">
              Service Area
            </h4>
            <div className="flex items-start gap-4 text-soft-dark font-light text-sm" data-id="element-76" data-mp="3tb19tzyeyojm">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-soft-terracotta/60" strokeWidth={1.5} data-id="element-77" data-mp="2ag5eqppkvag4" />
              
              <p className="leading-relaxed" data-id="element-78" data-mp="25mu6ck54alm3">
                Proudly serving Santa Barbara, California and surrounding local
                areas exclusively.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-soft-terracotta/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-light text-soft-muted tracking-wide" data-id="element-79" data-mp="1wlmas9tzjyvp">
          <p data-id="element-80" data-mp="2pcw4e79g97sj">
            © {new Date().getFullYear()} Wishing Tree Events. All rights
            reserved.
          </p>
          <p data-id="element-81" data-mp="2kfe2v1xrhuuk">Designed with care in Santa Barbara.</p>
        </div>
      </div>
    </footer>;
}